import { SocketIo } from "@/utils/socket";

export class JoinMeetingService extends SocketIo {
  wsDataList = []; // ws消息存储

  handleList = {}; // 处理ws消息方法列表

  // 初始化io链接
  constructor(token, connectCallback, disconnectCallback) {
    // const path = "/";
    const query = { token };
    const url = process.env.VUE_APP_BASE_SOCKET_URL;

    super(url, { query }, connectCallback, disconnectCallback);

    // this.bindOnEvent();
    // this.intervalProcess();
  }

  on(event, callback) {
    super.on(event, data => {
      // console.log("super.on::event", event);
      // console.log("super.on::data", data);
      try {
        const jsonData = data ? JSON.parse(data) : data;
        // this.log(event, data);
        callback(jsonData);
      } catch (error) {
        if (error instanceof SyntaxError) {
          // json解析异常
          callback(data);
        } else {
          console.error(error);
        }
      }
    });
  }

  log(name, data) {
    if (this.wsDataList.length >= 100000) {
      this.wsDataList.splice(0, 1000);
    }
    this.wsDataList.push({ name, data });
    console.log(this.wsDataList);
  }

  // 绑定事件，存储到wsDataList，定时处理
  bindSaveEventData(name, data) {
    this.wsDataList.push({
      name,
      data
    });
    console.log(this.wsDataList);
  }

  handleEventProcess() {
    while (this.wsDataList.length > 0) {
      const { name, data } = this.wsDataList.shift();
      const func = this.handleList[name];
      func(data);
    }
  }

  // 定时处理

  intervalProcess() {
    setInterval(() => {
      // console.log("处理开始")
      this.handleEventProcess();
      // console.log("处理结束")
    }, 500);
  }

  bindOnEvent() {
    const eventList = [
      "party",
      "conf",
      "partyTalk",
      "qaList",
      "qaFloorParty",
      "removeParty",
      "updatePartyRole",
      "modifyPartyInfo"
    ];

    eventList.forEach(eventName => {
      this.on(eventName, jsonData => {
        this.bindSaveEventData(eventName, jsonData);
      });
    });
  }

  bindHandle(eventName, cb) {
    this.handleList[eventName] = cb;
  }

  // emitJoin(billingcode) {
  //   // console.log("join:" + billingcode);
  //   this.emit("join", billingcode);
  // }

  // 绑定io事件 party 参与人事件
  // 关闭socket
  onParty(cb) {
    // this.bindHandle("party", cb)
    this.on("party", cb);
  }

  onConf(cb) {
    // this.bindHandle("conf", cb)
    this.on("conf", cb);
  }

  onPartyTalk(cb) {
    // this.bindHandle("partyTalk", cb)
    this.on("partyTalk", cb);
  }

  onQaList(cb) {
    // this.bindHandle("qaList", cb)
    this.on("qaList", cb);
  }

  onQaFloorParty(cb) {
    // this.bindHandle("qaFloorParty", cb)
    this.on("qaFloorParty", cb);
  }

  onRemoveParty(cb) {
    // this.bindHandle("removeParty", cb)
    this.on("removeParty", cb);
  }

  onUpdatePartyRole(cb) {
    // this.bindHandle("updatePartyRole", cb)
    this.on("updatePartyRole", cb);
  }

  onModifyPartyInfo(cb) {
    // this.bindHandle("modifyPartyInfo", cb)
    this.on("modifyPartyInfo", cb);
  }

  // 绑定事件处理函数
}
